module.exports = __webpack_public_path__ + "img/icon_attribute_happy_64.3aa8d72c.png";